var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { Product } from 'models';
import { plainToInstance } from 'class-transformer';
var ProductCategory = /** @class */ (function (_super) {
    __extends(ProductCategory, _super);
    function ProductCategory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductCategory.prototype.getId = function () {
        return Number(this.id);
    };
    ProductCategory.prototype.getName = function () {
        return this.name;
    };
    ProductCategory.prototype.getCreatedAt = function () {
        if (!this.created_at)
            return '';
        var createdAt = new Date(this.created_at);
        if (!this.isDateValid(createdAt))
            return '';
        return this.dateFormatter(createdAt, 'D MMM YYYY, hh:mm A');
    };
    ProductCategory.prototype.getProducts = function () {
        return plainToInstance(Product, this.products);
    };
    ProductCategory.prototype.setName = function (name) {
        this.name = name;
    };
    return ProductCategory;
}(Model));
export default ProductCategory;
